import { render, staticRenderFns } from "./AppFormGroup.vue?vue&type=template&id=b5f78920&scoped=true&"
import script from "./AppFormGroup.vue?vue&type=script&lang=js&"
export * from "./AppFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppFormGroup.vue?vue&type=style&index=0&id=b5f78920&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f78920",
  null
  
)

export default component.exports